import { Chip } from '@/shared/ui/Chip';
import { useSelect } from '../hooks/useCoreContext';
import { useTranslation } from 'react-i18next';
import { formPlaceholderTradPrefix } from '@/legacy/i18n';

const CHIP_MAX_WIDTH = '140px';

const SelectPills = () => {
	const { selectedOptions, toggleItem, unselectAll, isAllActive, useAllSentinel } = useSelect();
	const { t } = useTranslation();
	const { t: tc } = useTranslation('common');

	return (
		<ul className='flex flex-wrap gap-1'>
			{isAllActive && useAllSentinel && (
				<li>
					<Chip
						label={t(`${formPlaceholderTradPrefix}.all_selected`)}
						maxWidth={CHIP_MAX_WIDTH}
						onRemove={unselectAll}
						removeAriaLabel={tc('remove')}
					/>
				</li>
			)}
			{selectedOptions.length > 0 && selectedOptions.length <= 1
				? selectedOptions.map((opt) => (
						<li key={opt.value}>
							<Chip
								label={opt.notTranslatable ? opt.label : t(opt.label)}
								notranslate={opt.notTranslatable}
								maxWidth={CHIP_MAX_WIDTH}
								onRemove={() => toggleItem(opt.value)}
								removeAriaLabel={tc('remove')}
							/>
						</li>
					))
				: selectedOptions.length > 1 && (
						<li>
							<Chip
								label={`${selectedOptions.length} selected`}
								maxWidth={CHIP_MAX_WIDTH}
								onRemove={unselectAll}
								removeAriaLabel={tc('remove')}
							/>
						</li>
					)}
		</ul>
	);
};

export default SelectPills;
